<section>
    <xm-media-image [imageOptions]="imageOptions" size="height" center="hoz"></xm-media-image>
    <h2 class="heading">{{ pageData.headline }}</h2>
    <div class="details">{{ pageData.subhead }}</div>
    <button class="xm-btn-primary-light promise-btn" [promiseBtn]="refreshPromise" (promiseClick)="refreshPage()"><span>{{ pageData.retry }}</span></button>
</section>
